'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ItemsList = require('./components/ItemsList.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ItemsList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/items-list/index.js
// module id = 1041
// module chunks = 0